import { render, staticRenderFns } from "./Accountants.vue?vue&type=template&id=c224f38e&scoped=true"
import script from "./Accountants.vue?vue&type=script&lang=js"
export * from "./Accountants.vue?vue&type=script&lang=js"
import style0 from "./Accountants.vue?vue&type=style&index=0&id=c224f38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c224f38e",
  null
  
)

export default component.exports